import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AccountImportModel } from '../models/AccountImportModel.model';

@Injectable()
export class AccountImportService {
	endpointBase = '/api/coa-import';

	constructor(private readonly http: HttpClient) {}

	validate(data: AccountImportModel[]): Observable<any> {
		return this.http.post(this.endpointBase + '/validate', data);
	}

	import(data: AccountImportModel[]): Observable<any> {
		return this.http.post(this.endpointBase + '/import', data);
	}

	generateReport(data: AccountImportModel[], asPdf: boolean): Observable<any> {
		return this.http.post(this.endpointBase + '/report', { Data: data, AsPdf: asPdf });
	}
}
